import React, { memo } from "react";
import styled from "styled-components";
import { ISlot } from "../../../types";
import { SlotIcons } from "../slot-icons/slot-icons";

const SlotStyle = styled.div`
  position: relative;
  display: inline-block;
  text-align: center;
  color: ${(props) => props.theme.textColor};
  text-decoration: none;
  padding: 6px 0;
  margin: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  cursor: pointer;
  height: 30px;
  width: 60px;

  &:hover,
  &.isSelected {
    background-color: ${(props) => props.theme.primaryColor};
    color: ${(props) => props.theme.invertFontColor};
  }
`;

const Slot = (props: ISlot) => {
  const handleClick = (event: any) => {
    props.onClick(props.value);
  };

  return (
    <SlotStyle
      onClick={handleClick}
      className={props.isSelected ? "slot-item isSelected" : "slot-item"}
    >
      {props.icons ? <SlotIcons icons={props.icons} /> : ""}
      <span>{props.value}</span>
    </SlotStyle>
  );
};
export const SlotItem = memo(Slot);
